var throttle = require( 'lodash.throttle' );

var ScrollToTopButton = (function() {
  function C() { constructor.apply(this, arguments); };
	var p = C.prototype;
  function constructor( id ) {
		var self = this;
		this.button = document.getElementById( id );
		this.scrolledClass = id + '--scrolled';
		this.scrollPosition = window.innerHeight / 3;
		this.scrolled = false;
		document.addEventListener(
			'scroll', throttle( p.checkScrolled.bind( self ), 100 ), false );
		this.checkScrolled();
  };
	p.checkScrolled = function() {
		if ( window.scrollY > this.scrollPosition && !this.scrolled ) {
			this.button.classList.add( this.scrolledClass );
			this.scrolled = true;
		} else if (window.scrollY < this.scrollPosition && this.scrolled) {
			this.button.classList.remove( this.scrolledClass );
			this.scrolled = false;
		}
	};
  return C;
}());

export default ScrollToTopButton;
